/**
 * Reusable prev / next pager. All 7 list pages had their own copy with
 * subtly different button styling; this exposes a single API so they look
 * uniform.
 *
 * Renders nothing if `total <= pageSize` — caller doesn't need a guard.
 */

import { GlassButton } from '@/components/effects/index.js';

interface Props {
  offset: number;
  total: number;
  pageSize: number;
  onChange: (newOffset: number) => void;
  className?: string;
}

export function Pagination({
  offset,
  total,
  pageSize,
  onChange,
  className = '',
}: Props): JSX.Element | null {
  if (total <= pageSize) return null;
  const start = offset + 1;
  const end = Math.min(offset + pageSize, total);
  return (
    <div className={`flex items-center justify-center gap-3 mt-6 ${className}`}>
      <GlassButton
        size="sm"
        variant="ghost"
        onClick={(): void => onChange(Math.max(0, offset - pageSize))}
        disabled={offset === 0}
      >
        ← 上一页
      </GlassButton>
      <span className="text-xs text-slate-500 tabular-nums">
        {start} – {end} / {total}
      </span>
      <GlassButton
        size="sm"
        variant="ghost"
        onClick={(): void => onChange(offset + pageSize)}
        disabled={offset + pageSize >= total}
      >
        下一页 →
      </GlassButton>
    </div>
  );
}
